// src/redux/actions/reviewsActions.js

// import instance from '../../../axios';
import axios from "axios";

export const FETCH_STATS_REQUEST = "FETCH_STATS_REQUEST";
export const FETCH_STATS_SUCCESS = "FETCH_STATS_SUCCESS";
export const FETCH_STATS_FAILURE = "FETCH_STATS_FAILURE";
export const APPROVE_ALL_REQUEST = "APPROVE_ALL_REQUEST";
export const SYNC_REQUEST = "SYNC_REQUEST";
export const SAVE_LANGUAGE_REQUEST = "SAVE_LANGUAGE_REQUEST";
export const SAVE_RATING_REQUEST = "SAVE_RATING_REQUEST";
export const THEME_APP_EXTENSION_POPUP = "THEME_APP_EXTENSION_POPUP";
export const THEME_APP_EXTENSION_POPUP_SUCCESS = "THEME_APP_EXTENSION_POPUP_SUCCESS";
export const UPGRADE_POPUP_REQUEST = "UPGRADE_POPUP_REQUEST";

export const fetchStatsRequest = () => {
    return {
        type: FETCH_STATS_REQUEST,
    };
};

export const fetchStatsSuccess = (stats) => {
    return {
        type: FETCH_STATS_SUCCESS,
        payload: stats,
    };
};

export const fetchStatsFailure = (error) => {
    return {
        type: FETCH_STATS_FAILURE,
        payload: error,
    };
};

export const approveAllRequest = (error) => {
    return {
        type: APPROVE_ALL_REQUEST,
        payload: error,
    };
};

export const syncRequest = (error) => {
    return {
        type: SYNC_REQUEST,
        payload: error,
    };
};

export const saveLanguageRequest = () => {
    return {
        type: SAVE_LANGUAGE_REQUEST,
    };
};

export const saveRatingRequest = () => {
    return {
        type: SAVE_RATING_REQUEST,
    };
};

export const upgradePopupRequest = (error) => {
    return {
        type: UPGRADE_POPUP_REQUEST,
        payload: error,
    };
};

export const themeAppExtensionPopup = () => {
    return {
        type: THEME_APP_EXTENSION_POPUP,
    };
};

export const themeAppExtensionPopupSuccess = (data) => {
    return {
        type: THEME_APP_EXTENSION_POPUP_SUCCESS,
        payload: data,
    };
};

export const fetchStats = (page = 1, search = "") => {
    return async (dispatch) => {
        dispatch(fetchStatsRequest());
        try {
            const response = await axios.get(`/stats?page=${page}&search=${search}`);
            dispatch(fetchStatsSuccess(response.data));
        } catch (error) {
            dispatch(fetchStatsFailure(error.message));
        }
    };
};

export const approveAll = () => {
    return async (dispatch) => {
        dispatch(approveAllRequest());
        try {
            await axios.get("/reviews/approveAll");
            // dispatch(fetchStatsSuccess(response.data));
        } catch (error) {
            // dispatch(fetchStatsFailure(error.message));
        }
    };
};

export const sync = () => {
    return async (dispatch) => {
        dispatch(syncRequest());
        try {
            const response = await axios.get("/sync");
            dispatch(fetchStatsSuccess(response.data));
        } catch (error) {}
    };
};

export const saveLanguage = (lang) => {
    return async (dispatch) => {
        dispatch(saveLanguageRequest());
        try {
            await axios.get(`/save-language?lang=${lang}`);
        } catch (error) {
            console.log(error);
        }
    };
};

export const saveRating = (data) => {
    return async (dispatch) => {
        dispatch(saveRatingRequest());
        try {
            console.log("data :: ", data);
            const response = await axios.post("/save-app-rating", data);
            console.log("response :: ", response.data);
            dispatch(fetchStatsSuccess(response.data));
        } catch (error) {
            console.log(error);
        }
    };
};

export const upgradePopup = () => {
    return async (dispatch) => {
        dispatch(upgradePopupRequest());
        try {
            const response = await axios.get("/upgrade-popup");
            dispatch(fetchStatsSuccess(response.data));
        } catch (error) {}
    };
};

export const getThemeAppExtensionPopupStatus = () => {
    return async (dispatch) => {
        dispatch(themeAppExtensionPopup());
        try {
            const response = await axios.get("/theme-app-extension-popup");
            dispatch(themeAppExtensionPopupSuccess(response.data));
        } catch (error) {}
    };
};